// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"a10f8f19","876":"1dab63f2","987":"247aefb8"}[chunkId] + ".chunk.js";
};